const {
  CREATE_PR_REJECTED,
  CREATE_PR_SUCCESS,
  CREATE_PR_FETCH,
  UPDATE_PR_SUCCESS,
  UPDATE_PR_REJECTED,
  GET_PR_FETCH,
  GET_PR_SUCCESS,
  GET_PR_REJECTED,
  LIST_PR_FETCH,
  LIST_PR_SUCCESS,
  LIST_PR_REJECTED,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_REJECTED,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_REJECTED,
  GET_PR_DETAIL_FETCH,
  GET_PR_DETAIL_SUCCESS,
  GET_PR_DETAIL_REJECTED,
  GET_PR_EXPENSE_FETCH,
  GET_PR_EXPENSE_SUCCESS,
  GET_PR_EXPENSE_REJECTED,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_EXPENSE_REJECTED,
  GET_PR_BAL_BUDGET_FETCH,
  GET_PR_BAL_BUDGET_SUCCESS,
  GET_PR_BAL_BUDGET_REJECTED,
  UPDATE_PR_FETCH,
  UPDATE_PR_CLEAR,
  CREATE_PR_DETAIL_REMARK_SUCCESS,
  CREATE_PR_DETAIL_REMARK_REJECTED,
  CREATE_PR_DETAIL_REMARK_CLEAR,
  LIST_PR_DETAIL_REMARK_FETCH,
  LIST_PR_DETAIL_REMARK_SUCCESS,
  LIST_PR_DETAIL_REMARK_REJECTED,
  LIST_SUPPLIER_FETCH,
  LIST_SUPPLIER_SUCCESS,
  LIST_SUPPLIER_REJECTED,
  LIST_YEAR_FETCH,
  LIST_YEAR_SUCCESS,
  LIST_YEAR_REJECTED,
  LIST_PR_JOB_FETCH,
  LIST_PR_JOB_SUCCESS,
  LIST_PR_JOB_REJECTED,
  GET_PR_JOB_FETCH,
  GET_PR_JOB_SUCCESS,
  GET_PR_JOB_REJECTED,
  LIST_ASSIGNER_FETCH,
  LIST_ASSIGNER_SUCCESS,
  LIST_ASSIGNER_REJECTED,
  GET_PR_JOB_ITEM_FETCH,
  GET_PR_JOB_ITEM_SUCCESS,
  GET_PR_JOB_ITEM_REJECTED,
  ADD_DETAIL_REMARK_JOB_SUCCESS,
  ADD_DETAIL_REMARK_JOB_CLEAR,
  ADD_DETAIL_REMARK_JOB_REJECTED,
  LIST_DETAIL_REMARK_JOB_FETCH,
  LIST_DETAIL_REMARK_JOB_SUCCESS,
  LIST_DETAIL_REMARK_JOB_REJECTED,
  GET_COUNTRIES_FETCH,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_REJECTED,
  GET_PR_EXPENSE_JOB_FETCH,
  GET_PR_EXPENSE_JOB_SUCCESS,
  GET_PR_EXPENSE_JOB_REJECTED,
  GET_REMARK_STATUS_FETCH,
  GET_REMARK_STATUS_SUCCESS,
  GET_REMARK_STATUS_REJECTED,
} = require("src/Constants");

const initialState = {
  purchaseRequests: { data: [], isLoading: false, isRejected: false },
  purchaseRequestJobs: { data: [], isLoading: false, isRejected: false },
  purchaseRequestJob: { data: [], isLoading: false, isRejected: false },
  purchaseRequest: { data: [], isLoading: false, isRejected: false },
  budgetBalance: { data: [], isLoading: false, isRejected: false },
  purchaseRequesteExpense: { data: [], isLoading: false, isRejected: false },
  purchaseRequesteExpenseJob: { data: [], isLoading: false, isRejected: false },
  purchaseRequestDetails: { data: [], isLoading: false, isRejected: false },
  purchaseRequestSave: { message: null, isLoading: false, isRejected: false },
  purchaseRequestJobItem: { data: [], isLoading: false, isRejected: false },
  purchaseRequestRemarkStatus: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  expenseUpdate: {
    message: null,
    isLoading: false,
    isRejected: false,
  },
  purchaseRequestEdit: {
    message: null,
    isLoading: false,
    isSuccess: false,
    isRejected: false,
  },
  productAdd: {
    message: null,
    isSuccess: false,
    isRejected: false,
  },
  productDelete: { message: null, isLoading: true, isRejected: false },
  purchaseRequestDetailRemarkSave: {
    message: null,
    isRejected: false,
  },
  purchaseRequestDetailRemark: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  suppliers: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  years: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  assignees: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  remarkJobs: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  remarkJobSave: {
    message: null,
    isRejected: false,
  },
  remarkJobDelete: {
    message: null,
    isRejected: false,
  },
  countries: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  attachFiles: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  prSuppliers: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "get_purchase_detail_fetch": {
      return {
        ...state,
        purchaseRequestDetails: { isLoading: true, isRejected: false },
      };
    }
    case "get_purchase_detail_success": {
      return {
        ...state,
        purchaseRequestDetails: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    }
    case "get_purchase_detail_rejected": {
      return {
        ...state,
        purchaseRequestDetails: { isLoading: true, isRejected: false },
      };
    }
    case GET_REMARK_STATUS_FETCH: {
      return {
        ...state,
        purchaseRequestRemarkStatus: { isLoading: true, isRejected: false },
      };
    }
    case GET_REMARK_STATUS_SUCCESS: {
      return {
        ...state,
        purchaseRequestRemarkStatus: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    }
    case GET_REMARK_STATUS_REJECTED: {
      return {
        ...state,
        purchaseRequestRemarkStatus: { isLoading: false, isRejected: true },
      };
    }
    case GET_COUNTRIES_FETCH:
      return {
        ...state,
        countries: {
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_COUNTRIES_REJECTED:
      return {
        ...state,
        countries: {
          isLoading: false,
          isRejected: true,
        },
      };
    case ADD_DETAIL_REMARK_JOB_SUCCESS:
      return {
        ...state,
        remarkJobSave: {
          message: action.payload,
          isRejected: false,
        },
      };
    case ADD_DETAIL_REMARK_JOB_CLEAR:
      return {
        ...state,
        remarkJobSave: {
          message: null,
          isRejected: false,
        },
      };
    case ADD_DETAIL_REMARK_JOB_REJECTED:
      return {
        ...state,
        remarkJobSave: {
          message: action.payload,
          isRejected: true,
        },
      };
    case LIST_DETAIL_REMARK_JOB_FETCH: {
      return {
        ...state,
        remarkJobs: {
          isLoading: true,
          isRejected: false,
        },
      };
    }
    case LIST_DETAIL_REMARK_JOB_SUCCESS: {
      return {
        ...state,
        remarkJobs: {
          isLoading: false,
          isRejected: false,
          data: action.payload,
        },
      };
    }
    case LIST_DETAIL_REMARK_JOB_REJECTED: {
      return {
        ...state,
        remarkJobs: {
          isLoading: false,
          isRejected: true,
        },
      };
    }

    case GET_PR_JOB_ITEM_FETCH: {
      return {
        ...state,
        purchaseRequestJobItem: { isLoading: true, isRejected: false },
      };
    }
    case GET_PR_JOB_ITEM_SUCCESS: {
      return {
        ...state,
        purchaseRequestJobItem: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    }
    case GET_PR_JOB_ITEM_REJECTED: {
      return {
        ...state,
        purchaseRequestJobItem: { isLoading: false, isRejected: true },
      };
    }
    case LIST_ASSIGNER_FETCH: {
      return {
        ...state,
        assignees: { isLoading: true, isRejected: false },
      };
    }
    case LIST_ASSIGNER_SUCCESS: {
      return {
        ...state,
        assignees: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    }
    case LIST_ASSIGNER_REJECTED: {
      return {
        ...state,
        assignees: { isLoading: false, isRejected: true },
      };
    }
    case GET_PR_JOB_FETCH:
      return {
        ...state,
        purchaseRequestJob: { isLoading: true, isRejected: false },
      };
    case GET_PR_JOB_SUCCESS:
      return {
        ...state,
        purchaseRequestJob: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_PR_JOB_REJECTED:
      return {
        ...state,
        purchaseRequestJob: { isLoading: false, isRejected: true },
      };

    case LIST_YEAR_FETCH:
      return {
        ...state,
        years: {
          isLoading: true,
          isRejected: false,
        },
      };
    case LIST_YEAR_SUCCESS:
      return {
        ...state,
        years: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case LIST_YEAR_REJECTED:
      return {
        ...state,
        years: {
          isLoading: false,
          isRejected: true,
        },
      };
    case UPDATE_EXPENSE_SUCCESS:
      return {
        ...state,
        expenseUpdate: {
          isLoading: false,
          message: action.payload,
          isRejected: false,
        },
      };
    case UPDATE_EXPENSE_REJECTED:
      return {
        ...state,
        expenseUpdate: {
          isLoading: false,
          isRejected: true,
        },
      };

    case GET_PR_BAL_BUDGET_FETCH:
      return {
        ...state,
        budgetBalance: {
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_PR_BAL_BUDGET_SUCCESS:
      return {
        ...state,
        budgetBalance: {
          isLoading: false,
          data: action.payload,
          isRejected: false,
        },
      };
    case GET_PR_BAL_BUDGET_REJECTED:
      return {
        ...state,
        budgetBalance: {
          isLoading: false,
          isRejected: true,
        },
      };

    case GET_PR_EXPENSE_FETCH:
      return {
        ...state,
        purchaseRequesteExpense: {
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_PR_EXPENSE_SUCCESS:
      return {
        ...state,
        purchaseRequesteExpense: {
          isLoading: false,
          data: action.payload,
          isRejected: false,
        },
      };
    case GET_PR_EXPENSE_REJECTED:
      return {
        ...state,
        purchaseRequesteExpense: {
          isLoading: false,
          isRejected: true,
        },
      };

    case GET_PR_EXPENSE_JOB_FETCH:
      return {
        ...state,
        purchaseRequesteExpenseJob: {
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_PR_EXPENSE_JOB_SUCCESS:
      return {
        ...state,
        purchaseRequesteExpenseJob: {
          isLoading: false,
          data: action.payload,
          isRejected: false,
        },
      };
    case GET_PR_EXPENSE_JOB_REJECTED:
      return {
        ...state,
        purchaseRequesteExpenseJob: {
          isLoading: false,
          isRejected: true,
        },
      };

    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        productDelete: {
          message: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case DELETE_PRODUCT_REJECTED:
      return {
        ...state,
        productDelete: {
          message: action.payload,
          isLoading: false,
          isRejected: true,
        },
      };

    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        productAdd: {
          isSuccess: true,
          isRejected: false,
        },
      };

    case ADD_PRODUCT_REJECTED:
      return {
        ...state,
        productAdd: {
          message: action.payload,
          isSuccess: false,
          isRejected: true,
        },
      };

    case LIST_PR_FETCH:
      return {
        ...state,
        purchaseRequests: {
          isLoading: true,
          isRejected: false,
        },
      };

    case LIST_PR_SUCCESS:
      return {
        ...state,
        purchaseRequests: {
          isLoading: false,
          data: action.payload,
          isRejected: false,
        },
      };

    case LIST_PR_REJECTED:
      return {
        ...state,
        purchaseRequests: {
          isLoading: false,
          isRejected: true,
        },
      };

    case GET_PR_FETCH:
      return {
        ...state,
        purchaseRequest: {
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_PR_SUCCESS:
      return {
        ...state,
        purchaseRequest: {
          isLoading: false,
          data: action.payload,
          isRejected: false,
        },
      };
    case GET_PR_REJECTED:
      return {
        ...state,
        purchaseRequest: {
          isLoading: false,
          isRejected: true,
        },
      };
    case CREATE_PR_FETCH:
      return {
        ...state,
        purchaseRequestSave: {
          isLoading: true,
          isRejected: false,
        },
      };
    case CREATE_PR_SUCCESS:
      return {
        ...state,
        purchaseRequestSave: {
          isLoading: false,
          message: action.payload,
          isRejected: false,
        },
      };
    case CREATE_PR_REJECTED:
      return {
        ...state,
        purchaseRequestSave: {
          isLoading: false,
          isRejected: true,
        },
      };

    case UPDATE_PR_FETCH:
      return {
        ...state,
        purchaseRequestEdit: {
          isLoading: true,
          isSuccess: false,
          isRejected: false,
        },
      };
    case UPDATE_PR_SUCCESS:
      return {
        ...state,
        purchaseRequestEdit: {
          isLoading: false,
          isSuccess: true,
          message: action.payload,
          isRejected: false,
        },
      };
    case UPDATE_PR_CLEAR:
      return {
        ...state,
        purchaseRequestEdit: {
          isLoading: false,
          isSuccess: false,
          isRejected: false,
          message: null,
        },
      };
    case UPDATE_PR_REJECTED:
      return {
        ...state,
        purchaseRequestEdit: {
          isLoading: false,
          isSuccess: false,
          isRejected: true,
        },
      };
    case CREATE_PR_DETAIL_REMARK_SUCCESS:
      return {
        ...state,
        purchaseRequestDetailRemarkSave: {
          message: action.payload,
          isRejected: false,
        },
      };
    case CREATE_PR_DETAIL_REMARK_REJECTED:
      return {
        ...state,
        purchaseRequestDetailRemarkSave: {
          message: action.payload,
          isRejected: true,
        },
      };
    case CREATE_PR_DETAIL_REMARK_CLEAR:
      return {
        ...state,
        purchaseRequestDetailRemarkSave: {
          message: null,
          isRejected: false,
        },
      };
    case LIST_PR_DETAIL_REMARK_FETCH:
      return {
        ...state,
        purchaseRequestDetailRemark: {
          isLoading: true,
          isRejected: false,
        },
      };
    case LIST_PR_DETAIL_REMARK_SUCCESS:
      return {
        ...state,
        purchaseRequestDetailRemark: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case LIST_PR_DETAIL_REMARK_REJECTED:
      return {
        ...state,
        purchaseRequestDetailRemark: {
          isLoading: false,
          isRejected: true,
        },
      };
    case LIST_SUPPLIER_FETCH:
      return {
        ...state,
        suppliers: { isLoading: true, isRejected: false },
      };
    case LIST_SUPPLIER_SUCCESS:
      return {
        ...state,
        suppliers: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case LIST_SUPPLIER_REJECTED:
      return {
        ...state,
        suppliers: { isLoading: false, isRejected: true },
      };

    case LIST_PR_JOB_FETCH:
      return {
        ...state,
        purchaseRequestJobs: {
          isLoading: true,
          isRejected: false,
        },
      };

    case LIST_PR_JOB_SUCCESS:
      return {
        ...state,
        purchaseRequestJobs: {
          isLoading: false,
          data: action.payload,
          isRejected: false,
        },
      };

    case LIST_PR_JOB_REJECTED:
      return {
        ...state,
        purchaseRequestJobs: {
          isLoading: false,
          isRejected: true,
        },
      };

    case "get_attach_files_fetch":
      return {
        ...state,
        attachFiles: {
          isLoading: true,
          isRejected: false,
        },
      };
    case "get_attach_files_success":
      return {
        ...state,
        attachFiles: {
          isLoading: false,
          data: action.payload,
          isRejected: false,
        },
      };
    case "get_attach_files_rejected":
      return {
        ...state,
        attachFiles: {
          isLoading: false,
          isRejected: true,
        },
      };
    case "GET_PR_SUPPLIERS_SUCCESS":
      return {
        ...state,
        prSuppliers: action.payload,
      };

    default:
      return state;
  }
};
